<template
  ><nav class="gm-tabs" aria-label="Groove forms versions">
    <router-link to="/forms/new">New Groove forms</router-link
    ><router-link to="/forms">Groove forms legacy</router-link>
  </nav></template
>
<script>
export default { name: 'FormsNav' };
</script>
